import PropTypes from 'prop-types';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/TrueLinkRadios';
import { possessiverize } from 'react/shared/utils/Strings';
import AddressRadioLabel from 'react/signups/card/common/AddressRadioLabel';
import ErrorText from 'react/signups/card/common/ErrorText';
import addressShape from 'react/signups/card/shapes/AddressShape';

export default function ShippingForm({
  cardAccountSignupShippingEstimate,
  onChange,
  values,
  organizationAddress,
  cardholderAddress,
  cardholderFirstName,
}) {
  const options = [
    {
      label: (
        <AddressRadioLabel
          address={cardholderAddress}
          description={`${possessiverize(cardholderFirstName)} address`}
        />
      ),
      value: 'cardholder_home',
    },
    {
      label: <AddressRadioLabel address={organizationAddress} description="My address" />,
      value: 'office',
    },
  ];

  return (
    <>
      <CardText>
        Once approved, shipping usually takes {cardAccountSignupShippingEstimate} business days.
      </CardText>
      <TrueLinkRadios
        ariaLabel="What address should we ship the card to"
        name="shippingDestination"
        onChange={onChange}
        options={options}
        value={values.shippingDestination}
      />
      <ErrorText name="shippingDestination" />
    </>
  );
}

ShippingForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    shippingDestination: PropTypes.string,
  }).isRequired,
  organizationAddress: addressShape.isRequired,
  cardholderAddress: addressShape.isRequired,
  cardholderFirstName: PropTypes.string.isRequired,
  cardAccountSignupShippingEstimate: PropTypes.string.isRequired,
};
